import React, { useState, useEffect } from 'react';
// import strategywebsiterf from '../Images/Strategy/strategywebsiterf.png';
// import strategywebsiterf_1 from '../Images/Strategy/strategywebsiterf1.png';
// import strategywebsiterf_2 from '../Images/Strategy/strategywebsiterf2.png';

const featureData = [
  {
    id: 'DBI',
    title: 'Discovery & Research',
    // image: strategywebsiterf,
    description:
      'We start with listening. We dive deep into your industry, competitors, audience, and ambitions — gathering insights that fuel every creative decision.',
    bullets: [
      'Stakeholder workshops',
      'Competitor benchmarking',
      'Market and trend analysis',
      'Brand positioning audits',
    ],
  },
  {
    id: 'TAA',
    title: 'Ideation & R&D',
    // image: strategywebsiterf_1,
    description:
      'With research in hand, we shift into idea mode. This is where we generate bold concepts, test their potential, and align every idea with your business objectives.',
    bullets: [
      'Brainstorming sprints',
      'Innovation mapping',
      'R&D of branding frameworks',
      'Persona definition',
    ],
  },
  {
    id: 'DBP',
    title: 'Strategic Roadmapping',
    // image: strategywebsiterf_2,
    description:
      'Every great idea needs structure. We develop a tailored roadmap that charts your brand’s growth journey across digital, visual, and narrative dimensions.',
    bullets: [
      'Brand strategy architecture',
      'Messaging framework',
      'Visual identity planning',
      'Digital presence roadmap',
    ],
  },
  {
    id: 'MS',
    title: 'Execution Playbooks',
    // image: strategywebsiterf,
    description:
      'We don’t just strategize — we operationalize. Our playbooks translate strategy into executable actions, ensuring alignment across teams and platforms.',
    bullets: [
      'Social content & campaign plans',
      'Website and UI/UX design briefs',
      'Creative token allocation guides',
      'Branding timelines & checkpoints',
    ],
  },
  {
    id: 'DA',
    title: 'Iteration & Optimization',
    // image: strategywebsiterf,
    description:
      'Strategy doesn’t end at launch. We track performance, adapt to shifts, and keep improving — ensuring your brand evolves with its audience.',
    bullets: [
      'Feedback loops',
      'Real-time optimization',
      'Quarterly strategy recalibrations',
      'Growth-focused add-ons',
    ],
  },
];

function KeyFeat() {
  const [topOffsets, setTopOffsets] = useState({});
  const [activeCardIndex, setActiveCardIndex] = useState(0);

  useEffect(() => {
    const handleLoad = () => {
      const offsets = {};
      featureData.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el) {
          offsets[id] = el.getBoundingClientRect().top + window.scrollY;
        }
      });
      setTopOffsets(offsets);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener('load', handleLoad);
  }, []);

  const scrollToFeature = (id, index) => {
    setActiveCardIndex(index);
    if (topOffsets[id]) {
      window.scrollTo({
        top: topOffsets[id] - 100,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://scroll-driven-animations.style/demos/stacking-cards/css/';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <div className="wwc">
      <h1>KEY FEATURES</h1>

      {/* Optional Feature Button Nav */}
      {/* <div className="all-feats">
        {featureData.map((feat, idx) => (
          <div className="af" key={feat.id} onClick={() => scrollToFeature(feat.id, idx)}>
            <div className="whiteGlow"></div>
            <p className="afp">{feat.title.toUpperCase()}</p>
          </div>
        ))}
      </div> */}

      <div className="allFtImgs" id="cards">
        {featureData.map((feat, index) => (
          <div key={feat.id} className="afi card" id={`${feat.id} card_${index + 1}`}>
            <div className="afiImg">
              <img src={feat.image} alt={feat.title} style={{ width: '100%' }} />
            </div>
            <div className="afidesc">
              <h2>{feat.title}</h2>
              <p>{feat.description}</p>
              <ul className="bullet-list">
                {feat.bullets.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default KeyFeat;
